export type Environment =
  | 'coder'
  | 'development'
  | 'local'
  | 'staging'
  | 'production'
  | 'production-aus';

export const CONFIG_RESOLVER_MAP: {
  // Any used here because of how JSON is imported
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [env in Environment]: Record<string, any>;
} = {
  coder: require('../../config.coder.json'),
  development: require('../../config.development.json'),
  local: require('../../config.local.json'),
  production: require('../../config.production.json'),
  'production-aus': require('../../config.production-aus.json'),
  staging: require('../../config.staging.json'),
};

export const getConfig = (envOverride?: Environment) => {
  const nextEnv = process.env.NEXT_ENV as Environment | undefined;
  if (nextEnv === 'local' || nextEnv === 'coder') {
    return CONFIG_RESOLVER_MAP[nextEnv];
  }

  if (envOverride) {
    return CONFIG_RESOLVER_MAP[envOverride];
  }

  return nextEnv && nextEnv in CONFIG_RESOLVER_MAP
    ? CONFIG_RESOLVER_MAP[nextEnv]
    : CONFIG_RESOLVER_MAP.development;
};

export interface AgentPlatformSection {
  apiUrl?: string;
}

/** Empty means the environment has no platform; nothing falls back to a default host. */
export const resolveAgentPlatformUrl = (
  section: AgentPlatformSection | undefined,
  override?: string,
): string => override?.trim() || section?.apiUrl?.trim() || '';
